import { useAppSelector } from "app/store";
import { parseType } from "utils/gaiaobject-utils";

export const useGaiaObjectUiContent = (rawType?: string) => {
  const type = parseType(rawType);

  // Simply select from already-loaded data (loaded by Header component)
  const litigationUiContent = useAppSelector(
    (state) => state.litigationUiContent,
  );
  const noticeUiContent = useAppSelector((state) => state.noticeUiContent);
  const defaultUiContent = useAppSelector((state) => state.uiContent);

  if (type === "litigation") return litigationUiContent;
  if (type === "notice") return noticeUiContent;
  return defaultUiContent;
};
